/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnboardFoodicsUsersRequest
 */
export interface OnboardFoodicsUsersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OnboardFoodicsUsersRequest
     */
    ext_ids: Array<string>;
}

/**
 * Check if a given object implements the OnboardFoodicsUsersRequest interface.
 */
export function instanceOfOnboardFoodicsUsersRequest(value: object): value is OnboardFoodicsUsersRequest {
    if (!('ext_ids' in value) || value['ext_ids'] === undefined) return false;
    return true;
}

export function OnboardFoodicsUsersRequestFromJSON(json: any): OnboardFoodicsUsersRequest {
    return OnboardFoodicsUsersRequestFromJSONTyped(json, false);
}

export function OnboardFoodicsUsersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardFoodicsUsersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ext_ids': json['ext_ids'],
    };
}

export function OnboardFoodicsUsersRequestToJSON(json: any): OnboardFoodicsUsersRequest {
    return OnboardFoodicsUsersRequestToJSONTyped(json, false);
}

export function OnboardFoodicsUsersRequestToJSONTyped(value?: OnboardFoodicsUsersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ext_ids': value['ext_ids'],
    };
}

